export enum TaskType {
  cmsDays = 0,
  sbFactoryTickets = 1,
  functionalSupportTickets = 2,
}

export const TaskCsmDaysTypes = [TaskType.cmsDays];
export const TaskTicketsTypes = [TaskType.sbFactoryTickets, TaskType.functionalSupportTickets];
